var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.nbResults,
          expression: "nbResults",
        },
      ],
      staticClass: "toolbar",
    },
    [
      _c("div", { staticClass: "toolbar__nbresults" }, [
        _vm._v(_vm._s(_vm.countMessage)),
      ]),
      _vm._v(" "),
      _c("ShareDialog", {
        attrs: {
          hidden: !_vm.showShareDialog,
          link: _vm.linkSelected,
          toggleShareDialog: _vm.toggleShareDialog,
        },
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "toolbar__actions",
          class: { "toolbar__actions--hidden": _vm.hidden },
        },
        [
          _c("button", {
            staticClass: "toolbar__toggle",
            on: { click: _vm.toggle },
          }),
          _vm._v(" "),
          _c("span", { staticClass: "toolbar__count" }, [
            _vm._v(_vm._s(_vm.nbSelected ? _vm.nbSelected : " ")),
          ]),
          _vm._v(" "),
          _vm.nbSelected === 0
            ? _c("span", { staticClass: "toolbar__help" }, [
                _vm._v("\n      Use "),
                _c("input", {
                  staticClass: "customcheck",
                  attrs: {
                    checked: "checked",
                    disabled: "disabled",
                    type: "checkbox",
                  },
                }),
                _vm._v(" to select, share and compare\n    "),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.nbSelected && !_vm.showSelected
            ? _c(
                "button",
                {
                  staticClass: "toolbar__view-selected toolbar__action",
                  attrs: {
                    "data-gtm-category": "View selected/all",
                    "data-gtm-action": "View selected",
                    "data-gtm-label": _vm.linkSelected,
                  },
                  on: { click: _vm.setShowSelectedTrue },
                },
                [_vm._v("View selected (" + _vm._s(_vm.nbSelected) + ")")]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.nbSelected && _vm.showSelected
            ? _c(
                "button",
                {
                  staticClass: "toolbar__view-all toolbar__action",
                  attrs: {
                    "data-gtm-category": "View selected/all",
                    "data-gtm-action": "View all",
                    "data-gtm-label": "All",
                  },
                  on: { click: _vm.setShowSelectedFalse },
                },
                [_vm._v("View all")]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.nbSelected
            ? _c(
                "button",
                {
                  staticClass: "toolbar__share toolbar__action",
                  attrs: {
                    "data-gtm-category": "Share",
                    "data-gtm-action": "Share",
                    "data-gtm-label": _vm.linkSelected,
                  },
                  on: { click: _vm.toggleShareDialog },
                },
                [_vm._v("Share")]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.nbSelected
            ? _c(
                "button",
                {
                  staticClass: "toolbar__print toolbar__action",
                  attrs: {
                    "data-gtm-category": "Print",
                    "data-gtm-action": _vm.showSelected
                      ? "Print selection"
                      : "Print",
                    "data-gtm-label": _vm.showSelected
                      ? _vm.linkSelected
                      : "All",
                  },
                  on: { click: _vm.print },
                },
                [_vm._v("Print")]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.nbSelected
            ? _c(
                "button",
                {
                  staticClass: "toolbar__clear toolbar__action",
                  on: { click: _vm.clearWatchlist },
                },
                [_vm._v("Clear")]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.displayList
            ? _c(
                "button",
                {
                  staticClass: "toolbar__grid toolbar__action",
                  attrs: {
                    "data-gtm-category": "View",
                    "data-gtm-action": "View grid",
                    "data-gtm-label": "Switch to grid view",
                  },
                  on: { click: _vm.showGrid },
                },
                [_vm._v("Grid")]
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.displayList
            ? _c(
                "button",
                {
                  staticClass: "toolbar__list toolbar__action",
                  attrs: {
                    "data-gtm-category": "View",
                    "data-gtm-action": "View list",
                    "data-gtm-label": "Switch to list view",
                  },
                  on: { click: _vm.showList },
                },
                [_vm._v("List")]
              )
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }